import { ContentStateInterface, ContentStateProperty, DropdownOptionSelection } from '../@types/types'

export function getPropertyValue(
  obj: ContentStateInterface,
  path: ContentStateProperty
): string | DropdownOptionSelection {
  return path.split('.').reduce((o: any, p: string) => (o ? o[p] : undefined), obj)
}
